window.ENVIRONMENTS = {
    local: {
        hostTest: 'localhost',
        apiHost: 'https://api.dev.linkbi.cloud',
        apiPrefix: '',
        debug: true,
        maps: 'X3Mkj4ssGG-pfMJjKC2VfSuyUOML3hO57O4b1isa6F0',
        iconUrlPrefix: `${location.origin}/assets/images/asset-icons/`
    },
    test: {
        hostTest: 'linkbiwebappdevstorage.z6.web.core.windows.net',
        apiHost: 'https://api.dev.linkbi.cloud',
        apiPrefix: '',
        debug: true,
        maps: 'X3Mkj4ssGG-pfMJjKC2VfSuyUOML3hO57O4b1isa6F0'
    },
    development: {
        hostTest: 'portal.dev.linkbi.cloud',
        apiHost: 'https://api.dev.linkbi.cloud',
        apiPrefix: '',
        debug: true,
        maps: 'X3Mkj4ssGG-pfMJjKC2VfSuyUOML3hO57O4b1isa6F0'
    },
    beta: {
        hostTest: 'linkbibeta-haffb8d5afezebg3.z01.azurefd.net',
        apiHost: 'https://api.linkbi.cloud',
        apiPrefix: '',
        maps: 'X3Mkj4ssGG-pfMJjKC2VfSuyUOML3hO57O4b1isa6F0'
    },
    betaTest: {
        hostTest: 'linkbiwebappbetastorage.z6.web.core.windows.net',
        apiHost: 'https://api.linkbi.cloud',
        apiPrefix: '',
        maps: 'X3Mkj4ssGG-pfMJjKC2VfSuyUOML3hO57O4b1isa6F0'
    },
    production: {
        hostTest: 'bi.pvhlink.com',
        apiHost: 'https://api.linkbi.cloud',
        apiPrefix: '',
        maps: 'X3Mkj4ssGG-pfMJjKC2VfSuyUOML3hO57O4b1isa6F0'
    },
    production_alt: {
        hostTest: 'portal.linkbi.cloud',
        apiHost: 'https://api.linkbi.cloud',
        apiPrefix: '',
        maps: 'X3Mkj4ssGG-pfMJjKC2VfSuyUOML3hO57O4b1isa6F0'
    }
};

// Default
window.apiHost = 'https://api.dev.linkbi.cloud';
window.apiPrefix = '';// e.g. /v1

const configs = Object.keys(window.ENVIRONMENTS);
const env = window.location.protocol + '//' + window.location.hostname;

configs.forEach((key) => {
    if (window.ENVIRONMENTS[key].hostTest &&
        window.ENVIRONMENTS[key].hostTest.length > 0 &&
        env.indexOf(window.ENVIRONMENTS[key].hostTest) >= 0) {

        console.log('Using environment: ' + key);

        window.debug = window.ENVIRONMENTS[key].debug;
        window.apiHost = window.ENVIRONMENTS[key].apiHost;
        window.apiPrefix = window.ENVIRONMENTS[key].apiPrefix;
        window.maps = window.ENVIRONMENTS[key].maps;

        if (window.ENVIRONMENTS[key].iconUrlPrefix) {
            window.iconUrlPrefix = window.ENVIRONMENTS[key].iconUrlPrefix;
        }
    } else {
        console.warn('No config found for ' + env);
    }
});